import TouchAndMobile from './TouchAndMobile';
import State from './State';
import focusWithin from './FocusWithin';

const settings = {
    namespace: 'main-nav',
    header: '.header'
};

focusWithin(document);

new State(settings);
new TouchAndMobile(settings);

/*

If you save the TouchAndMobile into a variable like this
`let menu = new TouchAndMobile(settings);`
you'll get following optins:

menu.isTouch      boolean if the menu is on a touch device
menu.isOpen()     returns a boolean if the mobile menu is open
menu.open()       open the mobile menu and return true. If it is already open or not visible it returns false
menu.close()      close the mobile menu and return true. If it is already closed it returns false
menu.toggle()     toggle the menu (closes if open, open it if it is closed) return boolean status of the menu


If you want the react on the menu open or menu close event you can 
register event listener on mobileMenu.open and mobileMenu.close.
Example

document.addEventListener('mobileMenu.open', () => {
    // Do something on open
});

*/
